<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.tlho_cd_codigo }} - {{ $t('farm') }} : {{ item.fazenda }}
							</li>
						</template>
					</ExclusionAlert>
					<!-- <Button
            :label="$t('create')"
            color="trv-default"
            semanticClass="tiny"
            @click="showNewModelForm"
            widthAuto
          /> -->
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox
						v-model="tableHeaders"
						style="width: 85px; right: 4px"
					/>
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						:loading="exportando"
						@click="downloadCSVTalhao()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<GridPagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="totalRecords"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
				@refreshTable="refreshTabela"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 0.5rem">
					<Switcher
						v-model="model.ativo"
						style="margin-top: 1rem"
						:label="$t('activeSection')"
						:disabled="criandoTalhao"
						@input="atualiza_status_talhao()"
					/>
					<DropdownFk
						v-model="model.fk_fzda_fazenda"
						style="margin-top: 1rem; margin-bottom: 1rem"
						:label="$t('farm') + '*'"
						:dropdown-options="fazendas"
					/>
					<InputText
						:label="`${$t('area')} (ha)` + '*'"
						:value="model.tlho_md_area"
						@input="normalizeArea"
					/>

					<!-- <Accordion
            :label="$t('optionalFields')"
            :hints="[$t('soil'), $t('description')]"
          > -->
					<div style="display: flex; flex-direction: column; gap: 0.5rem">
						<DropdownFk
							v-model="model.fk_tpsl_tipo_solo"
							:label="$t('soil')"
							:dropdown-options="solos"
						/>
						<InputText
							v-model="model.tlho_ds_descricao"
							:label="$t('description')"
						/>
					</div>
					<!-- </Accordion> -->
					<Accordion :label="`${$t('customVariables')}`">
						<div
							v-if="model.tlho_jsonb_custom_variable.length"
							style="display: flex; flex-wrap: wrap; gap: 0.5rem; padding: 0.5rem"
						>
							<Tag
								v-for="{ name, value } in model.tlho_jsonb_custom_variable"
								:key="name"
								:identificador-da-tag="{ name, value }"
								:label="`${name}: ${value}`"
								:class-name="['default', 'outlined']"
							/>
						</div>
					</Accordion>
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>

		<ModalConfirm
			v-if="showModalConfirmacao"
			:disabled_item="model.tlho_cd_codigo"
			:item_type="$t('planting')"
			@desativar_registro="desativar_talhao()"
			@cancelar_desativacao="cancelar_desativar_talhao()"
		/>

		<ModalError
			v-if="showModalError"
			:ordens_servico="ordensDeServico"
			:disabled_item="model.tlho_cd_codigo"
			:item_type="$t('section')"
			@fechar_model_error="fecha_model_error()"
		/>
		<ModalConfirm
			v-if="showModalConfirmacao"
			:disabled_item="model.tlho_cd_codigo"
			:item_type="$t('planting')"
			@desativar_registro="desativar_talhao()"
			@cancelar_desativacao="cancelar_desativar_talhao()"
		/>

		<ModalError
			v-if="showModalError"
			:ordens_servico="ordensDeServico"
			:disabled_item="model.tlho_cd_codigo"
			:item_type="$t('section')"
			@fechar_model_error="fecha_model_error()"
		/>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import Switcher from '../../../../components/Switcher/Switcher'
import Accordion from '../../../../components/Accordion/Accordion'
import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import Tag from '../../../../components/Tag/Tag'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import GridPagination from '../../../../components/GridPagination/GridPagination.vue'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createTalhao,
	deleteTalhaoByIdList,
	getAllTalhoesPagination,
	updateTalhao,
} from '../../../../services/requests/TalhaoRequests'

import { getDropdownFazendas } from '../../../../services/requests/FazendaRequests'
import { getDropdownSolos } from '../../../../services/requests/SoloRequests'
import { exportarCsv } from '../../../../utils/csvHellpers'
import validarTalhao from '../../../../validations/TalhaoValidation'
import ModalConfirm from '../../../../components/ModalConfirm/ModalConfirm.vue'
import ModalError from '../../../../components/ModalError/ModalError.vue'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		Accordion,
		Button,
		CrudForm,
		CrudTable,
		Tag,
		DropdownFk,
		KebabMenu,
		DropdownCheckbox,
		InputSearch,
		InputText,
		GridPagination,
		Switcher,
		ModalConfirm,
		ModalError,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			criandoTalhao: false,
			desativou_talhao: false,
			showModalConfirmacao: false,
			showModalError: false,
			textFilter: '',
			totalRecords: 0,
			exportando: false,
			showExclusionAlert: false,
			headersSelecionados: [
				'tlho_cd_codigo',
				'tlho_ds_descricao',
				'tlho_md_area',
				'fazenda',
				'ativo',
			],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				fazenda: '',
				fk_fzda_fazenda: '',
				fk_tpsl_tipo_solo: '',
				id: '',
				solo: '',
				tlho_cd_codigo: '',
				tlho_ds_descricao: '',
				tlho_jsonb_custom_variable: [],
				tlho_md_area: '',
				ativo: true,
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'tlho_ds_descricao',
				titleCardPropertie: 'tlho_cd_codigo',
			},
			tableHeaders: [
				{ key: 'tlho_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'fazenda', value: this.$t('farm'), isActive: true },
				{
					key: 'tlho_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{ key: 'tlho_md_area', value: this.$t('area'), isActive: true },
				{ key: 'solo', value: this.$t('soil'), isActive: false },
				{
					key: 'ativo',
					value: this.$t('registration_status'),
					isActive: false,
				},
			],
			/**
			 * fazendas que serão dispostas no dropdown para atrelar ao talhão
			 */
			fazendas: [],

			/**
			 * solos que serão dispostos no dropdown para atrelar ao talhão
			 */
			solos: [],
		}
	},
	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.tlho_cd_codigo && this.model.fk_fzda_fazenda
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
		textFilter(value) {
			const pageNumber = 0
			const pageSize = 0
			this.refreshTabela(pageNumber, pageSize, value)
			this.$refs.ref__pagination.resetToFirstPageInputHandle()
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['tlho_cd_codigo']
		getAllTalhoesPagination().then((response) => {
			const talhoes = response.data.result
			this.totalRecords = talhoes.length > 0 ? talhoes[0].totalRegistros : 0
			talhoes.forEach((talhao) => this.formataTalhaoParaTabela(talhao))
			this.modelList = talhoes
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getDropdownFazendas().then((response) => {
			this.fazendas = response
		})

		getDropdownSolos().then((response) => {
			this.solos = response
		})
	},
	methods: {
		normalizeArea(value) {
			// Substitui vírgulas por pontos
			value = value.replace(',', '.')
			const numericValue = parseFloat(value)
			// Atualiza o modelo com o valor numérico ou vazio se inválido
			this.model.tlho_md_area = isNaN(numericValue) ? '' : numericValue
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createTalhaoToPost() {
			return {
				id: uuidv4(),
				fk_tpsl_tipo_solo: this.model.fk_tpsl_tipo_solo,
				tlho_ds_descricao: this.model.tlho_ds_descricao,
				fk_fzda_fazenda: this.model.fk_fzda_fazenda,
				tlho_cd_codigo: this.model.tlho_cd_codigo.trim(),
			}
		},

		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		/**
		 * Baixa CSV com o resultado FILTRADO COMPLETO (nao so a pagina ja
		 * carregada): busca tudo numa chamada antes de gerar o arquivo,
		 * sem mexer no estado da grid.
		 */
		async downloadCSVTalhao() {
			if (this.exportando) return
			this.exportando = true
			try {
				const response = await getAllTalhoesPagination(
					0,
					Math.max(this.totalRecords, 100),
					this.textFilter,
				)
				const items = response.data.result || []

				const cabecalhoDoCsvTlho = ['Código', 'Fazenda', 'Descrição', 'Área', 'Solo']

				const linhas = items.map((item) => [
					item.tlho_cd_codigo,
					item.fazenda,
					item.tlho_ds_descricao,
					item.tlho_md_area,
					item.solo,
				])

				exportarCsv('export_tlho', cabecalhoDoCsvTlho, linhas)
			} finally {
				this.exportando = false
			}
		},

		fecha_model_error() {
			this.showModalError = false
		},

		desativar_talhao() {
			this.update()
		},

		cancelar_desativar_talhao() {
			this.desativou_talhao = false
			this.showModalConfirmacao = false
			window.location.reload()
		},

		refreshTabela(pageNumber, pageSize, filteringWord) {
			getAllTalhoesPagination(pageNumber, pageSize, filteringWord).then((response) => {
				const talhoes = response.data.result
				if (!talhoes || talhoes.length === 0) {
					return
				}
				talhoes.forEach((talhao) => this.formataTalhaoParaTabela(talhao))
				this.modelList = talhoes
				this.tableConfiguration.statusTable = this.$t('noRecordFound')
			})
		},

		atualiza_status_talhao() {
			if (this.model.ativo == false) {
				this.desativou_talhao = true
			} else {
				this.desativou_talhao = false
			}
		},

		/**
		 * Seta fk de solo no model vinda do dropdown
		 */
		setSolo(value) {
			this.model.fk_tpsl_tipo_solo = value
		},

		/**
		 * Seta fk de fazenda no model vinda do dropdown
		 */
		setFazenda(value) {
			this.model.fk_fzda_fazenda = value
		},

		/**
		 * Cria um novo talhao no banco de dados
		 */
		create() {
			const talhao = this.createTalhaoToPost()
			const { isValid } = validarTalhao(talhao, this.modelList)

			if (isValid) {
				createTalhao(talhao).then((response) => {
					const { result: talhao, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						this.formataTalhaoParaTabela(talhao)
						this.modelList.unshift(talhao)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'fas fa-exclamation-circle',
							messageType: 'error',
						})
					}
				})
			} else {
				this.disableSaveButton = false
				this.mutationShowMessage({
					messageTitle: this.$t('campoPreenchidoIncorretamente'),
					messageIcon: 'fas fa-exclamation-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataTalhaoParaTabela(talhao) {
			talhao.isCheckedToDelete = false
			talhao.fzda_md_area = talhao.fzda_md_area?.toFixed(2)
			if (talhao.ativo == true) {
				talhao.ativo = this.$t('active')
			} else {
				talhao.ativo = this.$t('inactive')
			}
		},

		/**
		 * Atualiza talhao no banco de dados
		 */
		update() {
			updateTalhao(this.model).then((response) => {
				const talhao = response.data.resultado
				const isError = response.status
				this.disableSaveButton = false
				const ordensDeServico = response.data.ordensServicosAbertas
				this.disableSaveButton = false
				this.showModalConfirmacao = false
				if (isError == 200 && ordensDeServico.length == 0) {
					this.formataTalhaoParaTabela(talhao)

					const indexTalhao = this.modelList.map((talhao) => talhao.id).indexOf(talhao.id)
					this.$set(this.modelList, indexTalhao, talhao)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else if (isError == 200 && ordensDeServico.length > 0) {
					this.showModalError = true
					this.ordensDeServico = response.data.ordensServicosAbertas
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui talhao no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(talhao) =>
						this.modelsIdWithCheckedToDelete.includes(talhao.id) &&
						talhao.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteTalhaoByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var talhoesOrganizados = existeRegistroComDependencia
						.map((talhao) => `• Talhão: ${talhao.tlho_cd_codigo} / Fazenda: ${talhao.fazenda}`)
						.join('<br/>')
					var message = `<b>${this.$t('talhaoComDependenciaDePlantio')}:</b> <br/><br/> ${talhoesOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				if (this.desativou_talhao) {
					this.showModalConfirmacao = true
					this.showForm = false
					return
				}
				this.showForm = false
				if (this.model.ativo == 'Inativo') {
					this.model.ativo = false
				} else {
					this.model.ativo = true
				}
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(talhao) {
			this.model = Object.assign({}, talhao)
			this.criandoTalhao = false
			this.titleForm = `${this.$t('edit')} ${this.$t('section')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
			if (this.model.ativo == 'Inativo') {
				this.model.ativo = false
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()
			this.criandoTalhao = true
			this.titleForm = `${this.$t('create')} ${this.$t('section')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
